import { combineReducers } from "@reduxjs/toolkit";

import recovery from "./recovery/slice";

export default combineReducers({
  recovery,
});
